import React from "react";
import { Link } from "react-router-dom";

const NotActivated = () => {
  return (
    <div className="bg-email-bg h-screen text-center py-10 px-0">
      <div className="bg-white p-[60px] rounded-md inline-block mx-auto mt-20">
        <h1 className="font-black mx-auto text-[30px] w-[70%] mb-[20px] text-primary">
          Your account has not been activated. Kindly check your mail to
          activate your account.
        </h1>
        <p className="text-xl m-0 text-navy-blue">
          Kindly proceed to{" "}
          <span>
            <Link to="/" className="text-primary">
              Login
            </Link>
          </span>
        </p>
      </div>
    </div>
  );
};

export default NotActivated;
